export enum STALE_TIME {
  MS_100 = 100,
  SECONDS_1 = 1_000,
  SECONDS_10 = 10_000,
  MINUTES_1 = 60_000,
  MINUTES_10 = 600_000,
  HOURS_1 = 3_600_000,
}
